import React,{Component , useState, useEffect} from 'react';
import {Input,AutoComplete,Button} from 'antd';
import {withRouter} from 'react-router';
import style from './SearchBox.module.css';
import {SelectProps} from 'antd/es/select';

const searchResult=(query)=>{
    const testArr=[];
    return testArr.map((item,index)=>{
        let category='';
        // console.log('搜索组件的item')
        // console.log(query)
        if(item.includes(query)){
            category=item;
            return {
                value:category,
                label:(
                    <div style={{display:'flex',justifyContent:'space-between'}} >
                        <span> 
                            {category==''?null:(<a>{category}</a>)}
                        </span>
                    </div>
                )
            }
        }
        return {
            value:null,
            label:null,
        };
        
    });
}


const SearchBox=(props)=>{
    const {history} = props;
    const [options,setOptions]=useState([]);

    const handleSearch=(value)=>{
        if(value!=''){
            let result=searchResult(value).filter((item)=>{
                if (item.value != null)
                    return item;
            });
    
            setOptions(result);
        }else{
            setOptions([])
        }
        
           
    }

    const onSelect=()=>{
        // alert('要搜索的是:'+value)
        let searchInput=document.getElementsByName('search');
        // console.log(searchInput)
        let value=searchInput[0].value;
        if(value=='')
            return;
        history.push({pathname: `/searchResult/${value}`})
    }

    return (

        <div style={{display:'flex',flexDirection:'row',alignItems:'stretch',marginRight: 16}}>
            <AutoComplete
                dropdownMatchSelectWidth={252}
                style={{width:'350px'}}
                options={options}
                // onSelect={onSelect}
                onSearch={handleSearch}
            >

                <Input.Search name="search" size="large" placeholder="搜索经纬通达"/>
                
            </AutoComplete>
            <Button style={{height:'auto',borderRadius:'none',backgroundColor:'#181818',color:'#FFF'}} onClick={onSelect}>搜索</Button>
        </div>
    );
}



export default withRouter(SearchBox);